import { render, staticRenderFns } from "./DialogoPedidosCompraProdutos.vue?vue&type=template&id=b7127a56&scoped=true&"
import script from "./DialogoPedidosCompraProdutos.vue?vue&type=script&setup=true&lang=js&"
export * from "./DialogoPedidosCompraProdutos.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7127a56",
  null
  
)

export default component.exports